import * as Mod1 from "./discourse/adapters/anniversary";
import * as Mod2 from "./discourse/adapters/birthday";
import * as Mod3 from "./discourse/adapters/cakeday";
import * as Mod4 from "./discourse/components/emoji-images";
import * as Mod5 from "./discourse/components/user-info-list";
import * as Mod6 from "./discourse/connectors/user-card-post-names/user-card-cakeday.gjs";
import * as Mod7 from "./discourse/connectors/user-custom-preferences/user-date-of-birth-input.gjs";
import * as Mod8 from "./discourse/connectors/user-post-names/user-cakeday.gjs";
import * as Mod9 from "./discourse/controllers/cakeday";
import * as Mod10 from "./discourse/controllers/cakeday/anniversaries/all";
import * as Mod11 from "./discourse/controllers/cakeday/anniversaries/today";
import * as Mod12 from "./discourse/controllers/cakeday/anniversaries/tomorrow";
import * as Mod13 from "./discourse/controllers/cakeday/anniversaries/upcoming";
import * as Mod14 from "./discourse/controllers/cakeday/birthdays/all";
import * as Mod15 from "./discourse/controllers/cakeday/birthdays/today";
import * as Mod16 from "./discourse/controllers/cakeday/birthdays/tomorrow";
import * as Mod17 from "./discourse/controllers/cakeday/birthdays/upcoming";
import * as Mod18 from "./discourse/discourse-cakeday-route-map";
import * as Mod19 from "./discourse/initializers/cakeday-admin-plugin-configuration-nav";
import * as Mod20 from "./discourse/initializers/cakeday";
import * as Mod21 from "./discourse/lib/cakeday";
import * as Mod22 from "./discourse/routes/build-cakeday-route";
import * as Mod23 from "./discourse/routes/cakeday/anniversaries";
import * as Mod24 from "./discourse/routes/cakeday/anniversaries/all";
import * as Mod25 from "./discourse/routes/cakeday/anniversaries/index";
import * as Mod26 from "./discourse/routes/cakeday/anniversaries/today";
import * as Mod27 from "./discourse/routes/cakeday/anniversaries/tomorrow";
import * as Mod28 from "./discourse/routes/cakeday/anniversaries/upcoming";
import * as Mod29 from "./discourse/routes/cakeday/birthdays";
import * as Mod30 from "./discourse/routes/cakeday/birthdays/all";
import * as Mod31 from "./discourse/routes/cakeday/birthdays/index";
import * as Mod32 from "./discourse/routes/cakeday/birthdays/today";
import * as Mod33 from "./discourse/routes/cakeday/birthdays/tomorrow";
import * as Mod34 from "./discourse/routes/cakeday/birthdays/upcoming";
import * as Mod35 from "./discourse/templates/cakeday";
import * as Mod36 from "./discourse/templates/cakeday/anniversaries";
import * as Mod37 from "./discourse/templates/cakeday/anniversaries/all";
import * as Mod38 from "./discourse/templates/cakeday/anniversaries/today";
import * as Mod39 from "./discourse/templates/cakeday/anniversaries/tomorrow";
import * as Mod40 from "./discourse/templates/cakeday/anniversaries/upcoming";
import * as Mod41 from "./discourse/templates/cakeday/birthdays";
import * as Mod42 from "./discourse/templates/cakeday/birthdays/all";
import * as Mod43 from "./discourse/templates/cakeday/birthdays/today";
import * as Mod44 from "./discourse/templates/cakeday/birthdays/tomorrow";
import * as Mod45 from "./discourse/templates/cakeday/birthdays/upcoming";
const compatModules = {
  "discourse/adapters/anniversary": Mod1,
  "discourse/adapters/birthday": Mod2,
  "discourse/adapters/cakeday": Mod3,
  "discourse/components/emoji-images": Mod4,
  "discourse/components/user-info-list": Mod5,
  "discourse/connectors/user-card-post-names/user-card-cakeday": Mod6,
  "discourse/connectors/user-custom-preferences/user-date-of-birth-input": Mod7,
  "discourse/connectors/user-post-names/user-cakeday": Mod8,
  "discourse/controllers/cakeday": Mod9,
  "discourse/controllers/cakeday/anniversaries/all": Mod10,
  "discourse/controllers/cakeday/anniversaries/today": Mod11,
  "discourse/controllers/cakeday/anniversaries/tomorrow": Mod12,
  "discourse/controllers/cakeday/anniversaries/upcoming": Mod13,
  "discourse/controllers/cakeday/birthdays/all": Mod14,
  "discourse/controllers/cakeday/birthdays/today": Mod15,
  "discourse/controllers/cakeday/birthdays/tomorrow": Mod16,
  "discourse/controllers/cakeday/birthdays/upcoming": Mod17,
  "discourse/discourse-cakeday-route-map": Mod18,
  "discourse/initializers/cakeday-admin-plugin-configuration-nav": Mod19,
  "discourse/initializers/cakeday": Mod20,
  "discourse/lib/cakeday": Mod21,
  "discourse/routes/build-cakeday-route": Mod22,
  "discourse/routes/cakeday/anniversaries": Mod23,
  "discourse/routes/cakeday/anniversaries/all": Mod24,
  "discourse/routes/cakeday/anniversaries/index": Mod25,
  "discourse/routes/cakeday/anniversaries/today": Mod26,
  "discourse/routes/cakeday/anniversaries/tomorrow": Mod27,
  "discourse/routes/cakeday/anniversaries/upcoming": Mod28,
  "discourse/routes/cakeday/birthdays": Mod29,
  "discourse/routes/cakeday/birthdays/all": Mod30,
  "discourse/routes/cakeday/birthdays/index": Mod31,
  "discourse/routes/cakeday/birthdays/today": Mod32,
  "discourse/routes/cakeday/birthdays/tomorrow": Mod33,
  "discourse/routes/cakeday/birthdays/upcoming": Mod34,
  "discourse/templates/cakeday": Mod35,
  "discourse/templates/cakeday/anniversaries": Mod36,
  "discourse/templates/cakeday/anniversaries/all": Mod37,
  "discourse/templates/cakeday/anniversaries/today": Mod38,
  "discourse/templates/cakeday/anniversaries/tomorrow": Mod39,
  "discourse/templates/cakeday/anniversaries/upcoming": Mod40,
  "discourse/templates/cakeday/birthdays": Mod41,
  "discourse/templates/cakeday/birthdays/all": Mod42,
  "discourse/templates/cakeday/birthdays/today": Mod43,
  "discourse/templates/cakeday/birthdays/tomorrow": Mod44,
  "discourse/templates/cakeday/birthdays/upcoming": Mod45,
};
export default compatModules;
